module.exports = __webpack_public_path__ + "static/media/_MIC2373.image.8f871648.png";